import { useState } from 'react';
import { toast } from 'react-toastify';
import { Check, Copy, ExternalLink } from 'lucide-react';
import { copyToClipboard } from '../../lib/domain-expert-api';
import { btnSecondary, inputClass } from './ui';

export default function ExpertAppLinkCard({ loginUrl, isLoading }: { loginUrl?: string | null; isLoading?: boolean }) {
  const [copied, setCopied] = useState(false);

  const handleCopy = () => {
    if (!loginUrl) return;
    copyToClipboard(loginUrl).then((ok) => {
      if (ok) {
        setCopied(true);
        toast.success('Link copied');
        setTimeout(() => setCopied(false), 2000);
      } else {
        toast.error("Couldn't copy. Select the link and copy it.");
      }
    });
  };

  return (
    <div className="bg-white p-4 shadow ring-1 ring-black ring-opacity-5 sm:p-5">
      <h2 className="text-sm font-medium text-gray-900">Sign-in link for your users</h2>
      <p className="mt-1 text-sm text-gray-500">Share this link so your users can open the app and sign in.</p>
      <div className="mt-3 flex flex-col gap-2 sm:flex-row">
        <input
          readOnly
          aria-label="Sign-in link"
          value={isLoading ? 'Loading…' : loginUrl ?? ''}
          onFocus={(e) => e.target.select()}
          className={`${inputClass} font-mono text-gray-700 sm:flex-1`}
        />
        <div className="flex gap-2">
          <button type="button" onClick={handleCopy} disabled={!loginUrl} className={btnSecondary}>
            {copied ? <Check className="mr-2 h-4 w-4 text-green-600" /> : <Copy className="mr-2 h-4 w-4" />}
            Copy
          </button>
          {loginUrl ? (
            <a href={loginUrl} target="_blank" rel="noopener noreferrer" className={btnSecondary}>
              <ExternalLink className="mr-2 h-4 w-4" />
              Open
            </a>
          ) : (
            <button type="button" disabled className={btnSecondary}>
              <ExternalLink className="mr-2 h-4 w-4" />
              Open
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
